module.exports = __webpack_public_path__ + "static/media/passport-service-department-of-foreign-affairs.99cfdfc0.png";